// AS3 is base theme
export enum Theme {
  BASE = 'BASE',
  A2B = 'A2B',
  DEP = 'DEP'
}